module.exports = __webpack_public_path__ + "img/api_grey.2bd8be4f.svg";